import React from 'react';
import { useQuery } from '@apollo/client';
import { getEventQuizzes, getEventPublicQuizzes } from 'graphql/queries';
import { EventQuizzes as Quizzes, EventQuizzesVariables } from 'graphql/queries/types/EventQuizzes';
import { QuizWithEventInfo as Quiz } from 'graphql/fragments/types/QuizWithEventInfo';
import { useEventContext, useUserContext } from 'contexts';
import { ErrorLocal, EventLink, EventLogo, QuizList, Spinner } from 'components';
import { Typography, Box, Stack } from '@mui/material';
import { useParams } from 'react-router-dom';

interface Props {
    eventId: number;
}

export const EventQuizSelector = (props: Props) => {
    const user = useUserContext();
    const { eventAlias } = useParams();
    const event = useEventContext();
    const {
        loading,
        error,
        data: quizzesData
        // refetch
    } = useQuery<Quizzes, EventQuizzesVariables>(user.isEventAdmin(eventAlias) ? getEventQuizzes : getEventPublicQuizzes, {
        variables: { eventId: props.eventId }
    });

    if (loading) return <Spinner />;
    if (error) return <ErrorLocal errorMessage="Error getting quizzes :(" errorDetails={error} />;
    if (!quizzesData) return <p>No data</p>;

    const quizzes = quizzesData.quiz_master_quizzes.map<Quiz>((eq) => ({
        ...eq,
        event: {
            id: event!.id,
            alias: event!.alias
        }
    }));

    const eventDescriptionParts: string[] | undefined = event?.description.split('</br>');

    return (
        <Box className="aq-content">
            <Typography variant="h2" sx={{marginTop: '1rem'}}>{event?.name}</Typography>
            <EventLogo />
            <Stack spacing={1} sx={{ paddingBottom: '10px', width: '80%' }}>
                {eventDescriptionParts?.map((part, index) => (
                    <Typography key={`description-${index}`} variant="subtitle1">{part}</Typography>
                ))}
            </Stack>
            <QuizList quizList={quizzes} />
            <EventLink />
        </Box>
    );
};
